import { IOption } from '../../form/components/form-select/form-select.model';

export const KEY_ENTRY_MODAL_CONSTANTS = {
  ARRIVE_HEADER: $localize`Arrive`,
  DEPART_HEADER: $localize`Depart`,
  RESET: $localize`Reset`,
  LABELS: {
    ORIGIN_CC: $localize`Origin CC`,
    ORIGIN_SLIC: $localize`Origin SLIC`,
    ORIGIN_SORT: $localize`Origin Sort`,
    DESTINATION_CC: $localize`Destination CC`,
    DESTINATION_SLIC: $localize`Destination SLIC`,
    DESTINATION_SORT: $localize`Destination Sort`,
    EQUIPMENT_NUMBER: $localize`Equipment Number`,
    EQUIPMENT_TYPE: $localize`Equipment Type`,
    SORT_DATE: $localize`Sort Date`,
    LOAD_SERVICE_LEVEL: $localize`Load Service Level`,
    DEPART_TIME: $localize`Depart Time`,
    ARRIVAL_TIME: $localize`Arrival Time`,
  },
  CANCEL_MODAL: $localize`Cancel`,
  BODY: $localize`Are you sure you want to cancel? Your changes will not be saved.`,
  CONFIRM_BUTTON: $localize`Yes, Cancel`,
  REJECT_BUTTON: $localize`No`,
};

export const KEY_ENTRY_FORM_CONTROLS = {
  ORIGIN_CC: 'origCC',
  ORIGIN_SLIC: 'origSlic',
  ORIGIN_SORT: 'origSort',
  DESTINATION_CC: 'destCC',
  DESTINATION_SLIC: 'destSLIC',
  DESTINATION_SORT: 'destSort',
  EQUIPMENT_NUMBER: 'equipmentNumber',
  EQUIPMENT_TYPE: 'equipmentType',
  SORT_DATE: 'sortDate',
  LOAD_SERVICE_LEVEL: 'loadServiceLevel',
  TIME: 'time',
};

export const SORT_OPTIONS: IOption[] = [
  { label: $localize`Sunrise - S`, value: 'S' },
  { label: $localize`Morning - M`, value: 'M' },
  { label: $localize`Day - D`, value: 'D' },
  { label: $localize`Twilight - T`, value: 'T' },
  { label: $localize`Night - N`, value: 'N' },
  { label: $localize`Preload - P`, value: 'P' },
  { label: $localize`Local - L`, value: 'L' },
  { label: $localize`Afternoon - A`, value: 'A' },
];

export const LOAD_SERVICE_LEVEL_OPTIONS: IOption[] = [
  { label: $localize`1DA`, value: '1DA' },
  { label: $localize`2DA`, value: '2DA' },
  { label: $localize`3DS`, value: '3DS' },
  { label: $localize`EAM`, value: 'EAM' },
  { label: $localize`GND`, value: 'GND' },
];

export const EQUIPMENT_TYPE_OPTIONS: IOption[] = [
  { label: $localize`Air Container`, value: '02' },
  { label: $localize`Trailer`, value: '04' },
  { label: $localize`Aircraft Belly`, value: '06' },
  { label: $localize`Package Car`, value: '07' },
  { label: $localize`Cage`, value: '13' },
];
